export const parseFeatureFlags = featureFlags => {
  try {
    if (!featureFlags) {
      return {}
    }

    if (typeof featureFlags === 'string') {
      return JSON.parse(featureFlags)
    }

    return JSON.parse(featureFlags.flags || '{}')
  } catch (error) {
    return {}
  }
}

export const isScopeLGOrderingEnabled = ({ doctorFeatureFlags, practiceFeatureFlags }) => {
  const doctorFlags = parseFeatureFlags(doctorFeatureFlags)
  const practiceFlags = parseFeatureFlags(practiceFeatureFlags)

  return !!doctorFlags.scopeLGOrdering || !!practiceFlags.scopeLGOrdering
}

export const getScopeLGOrderingEnabledForState = state =>
  isScopeLGOrderingEnabled({
    doctorFeatureFlags: state.profileReducer?.doctor?.user?.featureFlags,
    practiceFeatureFlags: state.practiceReducer?.accountOwner?.user?.featureFlags
  })

// LG-type scopes carry a per-order cap from the backend (maxQuantityLG / maxQuantityLGMini) on top of the plan limit.
// The backend only ever sends a positive cap; null / undefined means it was not returned and the plan limit wins.
// A plan limit of 0 (for example the grin-trial planOverride) is a real limit, the same way the Regular and Mini rows treat it.
export const resolveScopeMaxQuantity = ({ backendMaxQuantity, planMaxScopes }) => {
  if (backendMaxQuantity == null) {
    return planMaxScopes
  }

  if (planMaxScopes == null) {
    return backendMaxQuantity
  }

  return Math.min(planMaxScopes, backendMaxQuantity)
}

export const getScopeShippingPriceKey = ({ shippingCountry, totalScopesAmount }) => {
  if (!shippingCountry) {
    return null
  }

  if (totalScopesAmount < 30) {
    return `${shippingCountry.toLowerCase()}${totalScopesAmount}ScopesPriceId`
  }

  return `${shippingCountry.toLowerCase()}30+ScopesPriceId`
}

export const sumScopeQuantities = scopeQuantities =>
  Object.values(scopeQuantities || {}).reduce((total, quantity) => total + Number(quantity || 0), 0)
